import { z, isoZ } from 'my-zod'

export const dateAvailabilitySystemView = z.object({
  startDate: isoZ.date(),
  startTime: isoZ.time(),
  endOptions: z.object({ endDate: isoZ.date(), endTime: isoZ.time() }).array()
})
export type dateAvailabilitySystemView = z.infer<typeof dateAvailabilitySystemView>
